/**
 * Returns the environment specific app id for rendering the square payment form.
 */
export const getSquareAppId = (): string => {
  const runtimeEnv = process.env.RUNTIME_ENV ?? "development";

  const developmentPublishableKey = "sandbox-sq0idb-0haFqcgWLgzwUdA5WkSf3g";

  // These code paths can never be hit by tests
  /* istanbul ignore next */
  if (runtimeEnv === "production") {
    return "sq0idp-hstbKcCzYsEUlJg0MisoLQ";
  } else if (runtimeEnv === "t2") {
    return "sandbox-sq0idb-ehbt2vhm8Z15V_yaYTsuUA";
  } else if (runtimeEnv === "t1") {
    return "sandbox-sq0idb-WrdvwciGIdyrDSOERDqVpw";
  }

  return developmentPublishableKey;
};
